import React, { useMemo } from 'react'
import View from './view.js'

export default function Logic(props) {
  function getId(item) {
    return props.id ? item[props.id] : item.id ?? item._id
  }

  let fromValues = useMemo(() => {
    let valueSet = Array.isArray(props.value)
      ? new Set(props.value)
      : new Set([props.value])
    return props.from.filter(item => valueSet.has(getId(item)))
  }, [props.from, props.value])

  return <View {...props} from={fromValues} onClick={onClick} />

  function onClick(id) {
    if (typeof props.onChange !== 'function') return

    props.onChange(props.value.filter(item => item !== id))
  }
}
